export const csr = true;
export const ssr = true;
export const prerender = true;

// This is the function for the Lesson query.
// Query variable functions must be named <QueryName>Variables.
export function _CourseLessonVariables(this: any, event: any): any {
	const path = event.url.pathname;
	const pathParts = path.split('/');
	const courseSlug = pathParts[pathParts.length - 2];

	if (!courseSlug) {
		return this.error(400, 'no slug');
	}

	return {
		courseSlug
	};
}
